export
default {
        common:
        {
            langEn: 'English',     
            langZh: '简体中文',       
            langFt: '繁體中文',      
            langMl: 'Bahasa Melayu', 
            langYn: 'Tiếng Việt',   
            langJa: '日本語',         
            langKr: '한국어',       
            langFa: 'Français',    
            langTr: 'Türkçe',     
            langYin: 'Bahasa Indonesia', 
            langEs: 'Español'   
        },
        home: {
            h1: "MetaMask加密货币",
            h1B: "MetaMask加密货币银行",
            h1C: "DeFi Wallet加密货币",
            h1D: "Coinbase加密货币银行",
            h1E: "MetaMask储蓄银行",
            h1F: "USDT数字货币银行",
            h2: "邀请好友",
            h3: "提款账户",
            h4: "参与储蓄",
            h4B: "加密货币存款",
            h4C: "数字货币存款",
            h5: "精选理财",
            h5B: "秒合约交易",
            h6: "用户池",
            h7: "USDT账户",
            h8: "总产量",
            h9: "有效节点",
            h10: "参与者",
            h11: "收益",
            h12: "收益记录",
            h13: "地址",
            h14: "编号",
            h15: "常见问题",
            h16: "如何参与？",
            h17: "亲爱的用户，如果您想参与USDT钱包储蓄，需遵守平台用户规则，严格执行平台决定，接受风险部门的监督，您将自动获得存款权限。欢迎参与，谢谢。",
            h17B: "亲爱的用户，如果您想参与USDT钱包储蓄，需遵守平台用户规则，严格执行平台决定，接受风险部门的监督，您将自动获得存款权限。欢迎参与，谢谢。",
            h18: "关于取款手续",
            h19: "每日产生的收益会自动存入账户余额，USDT提现成功后会自动添加到USDT钱包账户。",
            h19B: "点击出金选项，如果需要直接出金成为USDT，那么请填写你的正确钱包地址。 \n如果需要出金成为国家货币，那么请选择对应国家的银行卡绑定，然后填写你的银行卡信息。 \n填写完成资料后输入您要申请出金的金额，然后等待1-24小时就可以到账。",
            h20: "收入如何计算？",
            h21B: "成功注册后，您的储蓄账户将开始计算您的收益\n储蓄额1$-500$下可获得0.5%利息\n储蓄额500$以上可获得0.6%利息\n储蓄额1000$以上可获得0.7%利息\n储蓄额2000$以上可获得0.8%利息\n储蓄额3000$以上可获得0.9%利息\n储蓄额5000$以上可获得1%利息",
            h21: "成功加入后，储蓄合约将开始计算收益。",
            h22: "储蓄的收益来自哪里？",
            h23: "用户参与储蓄后，储蓄合约生效。每天 00:00、06:00、12:00、18:00 共 4 次结算利息。储蓄合约生效后，资金进入托管模式，平台负责资金安全。为保障账户资金安全，请严格遵守平台规则，如有问题请联系在线客服。",
            h23B: "用户参与储蓄后，储蓄合约生效。每天 00:00、06:00、12:00、18:00 共 4 次结算利息。储蓄合约生效后，资金进入托管模式，平台负责资金安全。为保障账户资金安全，请严格遵守平台规则，如有问题请联系在线客服。",
            h24: "奖金是多少？",
            h25: "您可以分享我的平台给好友。当好友参与后，您可获得其首次入金金额20%的推荐奖励，并永久获得其收益10%的推荐佣金。分享的公开链接在首页右上角。",
            h25B: "您可以分享本平台给好友。当好友参与后，您可获得其首次入金金额20%的推荐奖励，并永久获得其收益10%的推荐佣金。分享链接在首页右上角。",
            h26: "账户",
            h27: "总收入",
			
			h88: "平台背景",
			h89: "USDT\n成立时间：2008 年\n总部：美国纽约\n定位：智能投顾（Robo-Advisor）与金融科技（FinTech），提供自动化投资组合与现金管理\n监管机构：受金融中心交易委员会（SEC） 监管，同时是 FINRA 成员\n客户规模：管理资产超过 400 亿美元\n客户群体：超过 80 万名个人与企业客户",
			h90: "平台优势",
			h91: "✔️ 美国最早的 Robo-Advisor，经验成熟\n✔️ 投资组合基于现代资产配置理论（MPT），分散风险\n✔️ 提供 税收优化功能\n✔️ 高利率现金账户，流动性强\n✔️ 全程数字化操作，界面简洁",
			h92: "适合人群",
			h93: "★ 想要长期稳健投资、不想频繁操作的用户\n★ 需要自动化理财、省时省心的年轻投资者\n★ 投资 + 高息储蓄 + 退休账户的人群\n★ 想要低成本进入金融市场的普通投资者",
			h94: "奖金有多少？",
			h95: "您可以与您的朋友分享我的平台。如果他加入，您可以获得他首次存款金额的 20% 作为推荐奖金，您还可以随时获得他收入的 10% 作为推荐佣金。您的分享公司 链接在主页右上角。",
			h96: "复制",
			h97: "邀请链接",
			h98: "复制成功",
			h99: "复制失败",
            h28: "今日收益",
            h29: "理财收益",
            h30: "提现",
            h31: "记录",
            h32: "可用余额",
            h33: "提现金额",
            h34: "请输入提现金额",
            h35: "全部",
            h36: "提现",
            h37: "常见问题",
            h38: "有安全审计报告",
            h39: "合作伙伴",
            h40: "我们的业务伙伴",
            h41: "显示银行卡号",
            h42: "上一页",
            h43: "下一页",
            h44: "已经是第一页",
            h45: "请输入提现金额",
            h46: "余额不足",
            h47: "已经是最后一页",
            h48: "收入",
            h49: "支出",
            h50: "操作过于频繁，请稍后再试。",
            h51: "审计报告",
            h52: "存币生息",
            h53: "订单交易",
            h54: "注册奖励",
            h55: "邀请奖励",
            h56: "提现",
            h57: "充值",
            h58: "存款",
            h59: "取款",
            h60: "关于我们",
            h61: "感谢一直大力支持MetaMask银行的用户，为了让储蓄操作更方便，使用加密货币(USDT ETH BTC)进行转账储蓄即可获得储蓄奖励。储蓄1000 USDT以上奖励30 USDT，储蓄5000 USDT以上奖励200 USDT，储蓄10000 USDT以上可获得每次金额的5%奖励。（使用加密货币钱包提现同样享有此优惠）",
            h61B: "感谢一直大力支持Coinbase银行的用户，为了让储蓄操作更方便，使用加密货币(USDT ETH BTC)进行转账储蓄即可获得储蓄奖励。储蓄1000 USDT以上奖励30 USDT，储蓄5000 USDT以上奖励200 USDT，储蓄10000 USDT以上可获得每次金额的5%奖励。",
            h61C: "感谢一直大力支持MetaMask银行的用户，为了让储蓄操作更方便，使用加密货币(USDT ETH BTC)进行转账储蓄即可获得储蓄奖励。储蓄1000 USDT以上奖励30 USDT，储蓄5000 USDT以上奖励200 USDT，储蓄10000 USDT以上可获得每次金额的5%奖励。",
            h61D: "自2017年以来，USDT一直在帮助任何人和任何地方通过简化区块链资产访问来实现更高的财务自由。",
		},
        bankcard: {
            b1: "银行账户",
            b2: "金融机构名称",
            b3: "请输入金融机构名称",
            b4: "支行名称",
            b5: "请输入支行名称",
            b6: "支行号码",
            b7: "请输入支行号码",
            b8: "账号（普通）",
            b9: "请输入账号",
            b10: "假名",
            b11: "请输入用户名",
            b12: "账户名义",
            b13: "请输入账户名义人",
            b14: "绑定"
        },
        usdt: {
            u1: "我的订单",
            u2: "买入",
            u3: "请选择合约时间：",
            u4: "买入价格：",
            u5: "请输入买入金额",
            u6: "买涨",
            u7: "买跌",
            u8: "操作成功",
            u9: "至少一点",
			u10: "超出",
			u11: "金额必须更大",
			u12: "金额必须更小",
			u13: "余额不足以支付手续费",
			u14: "到期结算完成",
			u15: "当前价格",
			u17: "方向",
			u19: "手续费",
        },
        order: {
            o0: "我的订单",
            o1: "订单号",
            o2: "订单类型",
            o3: "买入金额",
            o4: "卖出金额",
            o5: "支付金额",
            o6: "合约时间",
            o7: "订单状态",
            o8: "结算状态",
            o9: "结算时间",
            o10: "下单时间",
            o11: "买涨",
            o12: "买跌",
            o13: "已卖出",
            o14: "盈利",
            o15: "亏损",
            o16: "已付费",
            o17: "盈亏平衡点"
        },
        recharge: {
            r1: "充值金额",
            r2: "充值金额数",
            r3: "充值类型",
            r4: "请选择",
            r5: "充值地址",
            r6: "转账交易订单号",
            r7: "已转账",
            r8: "审核中",
            r9: "输入不正确",
            r10: "请选择支付方式",
            r11: "最低充值金额为",
            r12: "充值上限金额为",
            r13: "请输入金额",
            r14: "上传支付截图",
            r15: "请上传支付截图",
            r16: "提交成功",
        },
        rechargeDetails: {
            r1: "充值记录",
            r2: "充值金额",
            r3: "审核中",
            r4: "充值成功",
            r5: "充值失败"
        },
		new:{
			h70:"数量",
			h71:"类型",
			h72:"时间",
			h80:"法币提现",
			h81:"线上提现",
			h82:"请输入提币地址",
			h83:"请输入提币数量",
			h84:"请选择提现类型",
			h85:"交易信息",
			h86:"最小提币额",
			h87:"手续费",
			h88:"预计到帐",
			h89:"提交",
			h90:"我的银行卡",
			h91:"更换银行卡",
			h910:"请先绑定银行卡",
			h911:"绑定银行卡",
			h92:"取消",
			h93:"确认",
			h94:"名称",
			h95:"价格",
			h96:"涨幅",
			h97:"提现金额输入有误",
			h98:"查看更多",
			h99:"账变记录",
			h60:"提现成功",
			h61:"提现失败",
			h62:"内容复制成功",
			h63:"币种",
			"h50": "PayPay提现",
			"h51": "输入PayPay ID",
			"h52": "输入电话号码",
			"h53": "上传PayPay二维码",
			"h54": "选择渠道",
			"h55": "充值网络"
		},
		api:{
			"提现超过限制次数":"提现超过限制次数",
			"两次提现间隔时间不得少于1小时":"两次提现间隔时间不得少于1小时",
			"提现超过限制次数":"提现超过限制次数",
			"提现申请":"提现申请",
			"提现金额未配置":"提现金额未配置",
			"禁止登录":"禁止登录",
			"您存在多笔待处理提现订单":"您存在多笔待处理提现订单",
			"低于最低提现额度":"低于最低提现额度",
			"提现超过限制":"提现超过限制",
			"请先绑定提现账号":"请先绑定提现账号",
			"処理":"処理",
			"银行不存在":"银行不存在",
			"处理中":"处理中",
			"订单交易":"订单交易",
			"邀请奖励":"邀请奖励",
			"秒合约订单结算":"秒合约订单结算",
			"获取火币行情失败":"获取火币行情失败",
			"用户数据不存在":"用户数据不存在",
			"没有此账号":"没有此账号",
			"邀请码不存在":"邀请码不存在",
			"注册奖励":"注册奖励",
			"用户提现":"用户提现",
			"失败请重试":"失败请重试",
			"请不要重复提交":"请不要重复提交",
			"用户名或密码错误":"用户名或密码错误",
			"密码不能为空":"密码不能为空",
			"用户名已存在":"用户名已存在",
			"用户名长度在4到12位之间":"用户名长度在4到12位之间",
			"密码格式为任意可见字符，长度在6~18之间":"密码格式为任意可见字符，长度在6~18之间",
			"密码错误次数太多":"密码错误次数太多",
			"旧密码不正确":"旧密码不正确",
			"昵称不能为空":"昵称不能为空",
			"允许的最长字符为16":"允许的最长字符为16",
			"图片不能为空":"图片不能为空",
			"用户不存在":"用户不存在",
			"用户余额错误":"用户余额错误",
			"手机区号错误":"手机区号错误",
			"手机号长度最小5位数":"手机号长度最小5位数",
			"手机号不能为空":"手机号不能为空",
			"验证码错误":"验证码错误",
			"充值通道已关闭":"充值通道已关闭",
			"充值金额不正确":"充值金额不正确",
			"最低充值额度100USDT":"最低充值额度100USDT",
			"提现通道已关闭":"提现通道已关闭",
			"提现金额不正确":"提现金额不正确",
			"请先绑定提现账号":"请先绑定提现账号",
			"低于最低提现额度":"低于最低提现额度",
			"您已绑定过银行卡":"您已绑定过银行卡",
			"两次提现间隔时间不得少于1小时":"两次提现间隔时间不得少于1小时",
			"登陆失败":"登陆失败",
			"秒合约订单结算":"秒合约订单结算",
			"秒合约下单手续费":"秒合约下单手续费",
			"存币生息":"存币生息",
			"提现":"提现",
			"充值":"充值",
			"上分": "今日储蓄",
			"下分": "今日提现",
			"存在未完成的提现订单":"存在未完成的提现订单",
			"两次提现间隔时间不得少于1分钟":"存在未完成的提现订单"
		},
		chat: {
			title: "在线客服",
			input: "请输入消息...",
			send: "发送",
			empty: "暂无消息，有问题请直接留言",
			loginFirst: "请先连接钱包登录",
			sendFail: "发送失败",
			uploading: "图片上传中",
			uploadFail: "图片上传失败"
		}
    }